import { render } from "./DetalharFuncionario.vue?vue&type=template&id=01f0de73&scoped=true"
import script from "./DetalharFuncionario.vue?vue&type=script&lang=js"
export * from "./DetalharFuncionario.vue?vue&type=script&lang=js"

import "./DetalharFuncionario.vue?vue&type=style&index=0&id=01f0de73&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01f0de73"]])

export default __exports__